module.exports = __webpack_public_path__ + "static/media/U1-T2-1-2c.a76cd6fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-2c.svg
// module id = 520
// module chunks = 0